<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Exam Live Dashboard</span>
        </v-row>
        <br />
        <v-card class="mx-auto card">
            <v-card-title class="heading justify-center">
                <span>Exam Live Dashboard</span>
            </v-card-title>
            <div>
                <div >
                    <v-row justify="center" style="padding:10px" >
                        <v-col lg="2" cols="12" sm="12"  >
                            <label>Exam</label>
                            <v-select placeholder="Select Exam" class="select" @change="findDates()" :items="exam_list" outlined dense item-text="exam_name" item-value="id" v-model="get.exam" persistent-hint></v-select>
                        </v-col>
                        <v-col lg="2" cols="12" sm="12">
                            <label>Exam Date</label>
                            <v-autocomplete placeholder="Select Date" class="select" :items="dates" outlined dense @change="findSlot()" v-model="get.date" persistent-hint></v-autocomplete>
                        </v-col>
                        <v-col lg="2" cols="12" sm="12">
                            <label>Slot No</label>
                            <v-autocomplete placeholder="Select Date" class="select" @change="findtime()" outlined dense :items="slot_list" item-value="id" item-text="slotNo" v-model="get.slotNo" persistent-hint></v-autocomplete>
                        </v-col>
                        <v-col lg="2" cols="12" sm="12">
                            <label class="bold">Start Time </label>
                            <v-text-field readonly v-model="get.startTime" outlined dense class="select"></v-text-field>
                        </v-col>
                        <v-col lg="2" cols="12" sm="12">
                            <label class="bold">End Time</label>
                            <v-text-field readonly v-model="get.endTime" outlined dense class="select"></v-text-field>
                        </v-col>
                        <!-- <v-col cols="2">
                     <label>Program Type</label>
                     <v-autocomplete placeholder="Select Program Type" class="select" :items="program_type_list" outlined dense item-text="progtype_name" item-value="id"  v-model="get.program_type" @change="getprograms()" persistent-hint></v-autocomplete>
                  </v-col>
                  <v-col cols="2">
                      <label>Program</label>
                     <v-autocomplete placeholder="Select Program" class="select" :items="program_list" outlined dense item-text="prog_name" item-value="id"  v-model="get.program" persistent-hint></v-autocomplete>
                  </v-col>
                  <v-col cols="2">
                      <label>Year</label>
                     <v-autocomplete placeholder="Select Year" class="select" :items="year_list" outlined dense item-text="year_name" item-value="id"  v-model="get.year" persistent-hint></v-autocomplete>
                  </v-col> -->

                    </v-row>
                    <v-row class="justify-center">
                            <v-col lg="1" cols="12" sm="12" style="padding-top:0">
                            <v-btn class=" button" :loading="loading4" :disabled="loading4" @click="getData">
                                Fetch
                                <template v-slot:loader>
                                    <span class="custom-loader">
                                        <v-icon light>cached</v-icon>
                                    </span>
                                </template>
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <template>
                <div v-if="exam_deatils">
                    <v-card-title>
                        Exam Live Dashboard
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table class="mytable" :headers="headers" :items="exam_deatils" :search="search">
                        <template v-slot:item.action1="{ item }">
                            <v-btn class="ma-2" :loading="loading4" :disabled="loading4" rounded color="info" @click="proceed(item)" v-model="details_id">Proceed </v-btn>
                        </template>
                    </v-data-table>
                </div>
            </template>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import moment from "moment";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            dates: [],
            slot_list: [],
            loading4: false,
            details_id: "",
            start_date: "",
            starttime: "",
            endtime: "",
            extratime: "",
            examstatuslist: "",
            extra: "",
            status: "",
            logs: "",
            procstatus: "",
            remtime: "",
            program_list: "",
            program_type_list: "",
            year_list: "",
            // program: null,
            // program_type: null,
            // year: null,
            get: {
                exam: null,
                program: null,
                program_type: null,
                year: null,
                date: null,
                startTime: null,
                endTime: null,
                slotNo: null,
            },
            headers: [
                { text: "Sr. No", value: "srno" },
                { text: "Exam", value: "exam" },
                // { text: "Session. No", value: "session_no" },
                { text: "Course", value: "course" },
                { text: "Exam Date", value: "exam_date" },
                { text: "Slot No.", value: "slot_no" },
                { text: "Start Time", value: "start_time" },
                { text: "End Time", value: "end_time" },
                { text: "Exam Status", value: "exam_status" },
                { text: "Proceed", align: "left", value: "action1" },
            ],

            exam_list: "",
            exam_deatils: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            examlearnerlist: "",
            search: "",
        }),

        mounted() {
            this.onLoad();
        },
        methods: {
            // getprograms() {
            //     this.loading4 = true;
            //     const formData = {
            //         program_type_id: this.get.program_type,
            //     };
            //     axios
            //         .post("ExamLiveDashbord/getprograms", formData)
            //         .then((res) => {
            //             if (res.data.msg == "200") {
            //                 this.loading4 = false;
            //                 this.program_list = res.data.program_list;
            //             } else {
            //                 this.loading4 = false;
            //                 this.showSnackbar("#b71c1c", "Something went wrong...");
            //             }
            //         })
            //         .catch((error) => {
            //             this.showSnackbar("#b71c1c", "Something went wrong...");
            //             this.loading4 = true;
            //         });
            // },

            onLoad() {
                axios
                    .post("ExamLiveDashbord/viewExamDashboard")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            //window.alert(res.data.msg)
                            if ((this.load = true)) {
                                this.exam_list = res.data.exam_list;
                                this.program_list = res.data.program_list;
                                this.program_type_list = res.data.program_type_list;
                                this.year_list = res.data.year_list;
                            }
                        } else {
                            window.console.log(res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        var overlay = false;
                    });
            },
            findtime() {
                const data = {
                    slot: this.get.slotNo,
                };
                axios
                    .post("/ExamLiveDashbord/getslottime", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.get.endTime = res.data.end_time;
                            this.get.startTime = res.data.start_time;
                        } else {
                            // alert("in else")
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        // alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            findDates() {
                const data = {
                    examId: this.get.exam,
                };
                axios
                    .post("/ExamLiveDashbord/getExamdates", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dates = res.data.dates;
                            // this.get.date = this.dates[0]
                        } else {
                            //  alert("in else")
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        //  alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            getData() {
                if (this.get.exam == null) {
                    this.showSnackbar("#b71c1c", "Please Select Exam.!!!");
                    return;
                }
                if (this.get.date == null) {
                    this.showSnackbar("#b71c1c", "Please Select Exam date.!!!");
                    return;
                }
                if (this.get.slotNo == null) {
                    this.showSnackbar("#b71c1c", "Please Select Slot No.!!!");
                    return;
                }

                let formatDate = moment(this.get.date, "DD-MM-YYYY").format("YYYY-MM-DD");

                const data = {
                    slot: this.get.slotNo,
                    exam: this.get.exam,
                    date: formatDate,
                };
                    if(this.get.exam !== null && this.get.slotNo !== null && this.get.date !== null){
                    this.loading4 = true;
                    axios
                        .post("ExamLiveDashbord/getExamDetails", data)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                this.loading4 = false;
                                this.exam_deatils = res.data.Exam_Details_List;
                                this.program = res.data.program;
                                this.program_type = res.data.program_type;
                                this.year = res.data.year;
                            } else {
                                this.loading4 = false;
                                this.showSnackbar("#b71c1c", "Something went wrong...");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            this.loading4 = true;
                        });
                }
            },

            findSlot() {
                let formatDate = moment(this.get.date, "DD-MM-YYYY").format("YYYY-MM-DD");
                // this.get.date = formatDate
                const data = {
                    date: formatDate,
                    exam: this.get.exam,
                };
                axios
                    .post("/ExamLiveDashbord/getSlot", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.slot_list = res.data.slot;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        // alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            proceed(item) {
                {
                    //alert("id...."+item.id)
                    this.loading4 = true;
                    this.$store.commit("setexam_id", item.id);
                    // this.$store.commit("setprogram_id", this.program);
                    // this.$store.commit("setprogram_type_id", this.program_type);
                    // this.$store.commit("setyear_id", this.year);
                    this.$router.push({ name: "student-proctor-status", target: "blank" });
                }
            },

            //         const formData = {
            //          timetableid:item,
            //      }
            //         axios
            //             .post("ExamLiveDashbord/getlearnerExamDetails", formData)
            //             .then((res) => {
            //                 if (res.data.msg == "200") {
            //                     this.loading4 = false;
            //                     this.examlearnerlist = res.data.Exam_Details_List;
            //                     this.start_date=res.data.Exam_Details_List[0].exam_date;
            //                     this.starttime=res.data.Exam_Details_List[0].start_time;
            //                     this.endtime=res.data.Exam_Details_List[0].end_time;
            //                     this.examstatuslist=res.data.examststatuslist;
            //                     this.procstatus=res.data.procststatuslist;
            //                     this.remtime=res.data.Exam_Details_List[0].remaining_time;

            //                 } else {
            //                     this.loading4 = false;
            //                     this.showSnackbar("#b71c1c", "Something went wrong...");
            //                 }
            //             })
            //             .catch((error) => {
            //                 this.showSnackbar("#b71c1c", "Something went wrong...");
            //                 this.loading4 = true;
            //             });
            //     }
            // },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },
        },
    };
</script>
<style scoped>
    .m {
        margin-top: 1.5rem;
    }
    .flex {
        display: flex;
        justify-content: center;
        background: aliceblue;
        margin: 10px;
    }
    .select >>> .v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }
    .button {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white;
    }
    .button:hover {
        background-color: white !important;
        color: hsla(190, 99%, 30%, 1) !important;
    }
    .mytable /deep/ thead th {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white !important;
        white-space: nowrap !important;
    }
    .mytable {
        margin: 10px;
        /* border:1px solid hsla(190, 99%, 30%, 1) */
    }
    .card {
        border: 2px solid hsla(190, 99%, 30%, 1) !important;
    }
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>
